import { render, staticRenderFns } from "./SelecionarTerritorio.vue?vue&type=template&id=1d9ef189&scoped=true&lang=pug"
import script from "./SelecionarTerritorio.vue?vue&type=script&lang=js"
export * from "./SelecionarTerritorio.vue?vue&type=script&lang=js"
import style0 from "./SelecionarTerritorio.vue?vue&type=style&index=0&id=1d9ef189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ef189",
  null
  
)

export default component.exports